export enum TenancyBroadcastMessageType {
  TenancySwitched = 'TenancySwitched',
}

export function createTenancyBroadcastChannel() {
  return new BroadcastChannel('bc-app-tenancy');
}
